import { Berth } from 'seacube-backend/src/api/client';

import { store } from './store';

// Geofence type may not yet be in the generated API typings.
type Geofence = any;

export const setBerths = (berths: Berth[]) => {
  store.mapLayers.berths.data = berths;
};

export const setBerthsDisplay = (display: boolean) => {
  store.mapLayers.berths.display = display;
};

// Geofences helpers
export const setGeofences = (geofences: Geofence[]) => {
  store.mapLayers.geofences.data = geofences;
};

export const setGeofencesDisplay = (display: boolean) => {
  store.mapLayers.geofences.display = display;
};

// Toggle display for a specific geofence type
export const toggleGeofenceType = (type: string) => {
  const selected = store.mapLayers.geofences.selectedTypes;
  if (selected.includes(type)) {
    store.mapLayers.geofences.selectedTypes = selected.filter(
      (t: string) => t !== type,
    );
  } else {
    store.mapLayers.geofences.selectedTypes = [...selected, type];
  }
};
